import React from 'react';
import { homeRoute } from './configList/homeRoute';
import { liveRoute } from './configList/liveRoute';
import { newLiveRoute } from './configList/newLiveRoute';
import { userRoute } from './configList/userRoute';
import { competitionRoute } from './configList/competitionRoute';
import { beautifulGirlRoute } from './configList/beautifulGirlRoute';
import { loginRoute } from './configList/loginRoute';

import LoginLayout from '@/views/login/layout';

export interface IRouteBase {
  // 路由路径
  path: string;
  // 路由组件
  component?: any;
  // 302 跳转
  redirect?: string;
  // 路由信息
  meta: IRouteMeta;
  // 是否校验权限, false 为不校验, 不存在该属性或者为true 为校验, 子路由会继承父路由的 auth 属性
  auth?: boolean;
}

export interface IRouteMeta {
  title: string;
  icon?: string;
  crumbs?: number;
}
export interface IRoute extends IRouteBase {
  children?: IRoute[];
  list?: IRoute[];
}

const routes: IRoute[] = [
  {
    path: '/updater',
    component: React.lazy(() => import('@/views/updater')),
    meta: {
      title: '升级提醒'
    }
  },
  {
    path: '/login',
    redirect: '/login/account',
    component: LoginLayout,
    meta: {
      title: '996传奇盒子'
    },
    children: [...loginRoute]
  },
  {
    path: '/competition/live',
    component: React.lazy(() => import('@/views/competition/live')),
    meta: {
      title: '直播弹窗'
    }
  },
  {
    path: '/voiceHome',
    component: React.lazy(() => import('@/views/Voice')),
    meta: {
      title: '语音弹窗'
    }
  },
  {
    path: '/voiceCommunity',
    component: React.lazy(() => import('@/views/VoiceCommunity')),
    meta: {
      title: '语音社区'
    }
  },
  {
    path: '/voiceCommunityGame',
    component: React.lazy(() => import('@/views/VoiceCommunityGame')),
    meta: {
      title: '语音社区游戏'
    }
  },
  {
    path: '/liveRaffleHome',
    component: React.lazy(() => import('@/views/NewLive/studio/liveRaffle')),
    meta: {
      title: '直播抽奖'
    }
  },
  {
    path: '/liveNotice',
    component: React.lazy(() => import('@/views/Live/liveNotices')),
    meta: {
      title: '开播提醒弹窗'
    }
  },
  {
    path: '/chatMsgNotice',
    component: React.lazy(() => import('@/components/baseChatModal/chatMsgNotice')),
    meta: {
      title: '聊天消息通知'
    }
  },
  {
    path: '/gameStatusNotice',
    component: React.lazy(() => import('@/components/baseChatModal/gameStatusNotice')),
    meta: {
      title: '游戏状态通知'
    }
  },
  {
    path: '/ViewWhisper',
    component: React.lazy(() => import('@/components/ViewWhisper')),
    meta: {
      title: '区服客服'
    }
  },
  {
    path: '/Notice',
    component: React.lazy(() => import('@/components/ViewWhisper/components/Notice')),
    meta: {
      title: '消息通知'
    }
  },
  {
    path: '/MessageWin',
    component: React.lazy(() => import('@/components/GameService/messageWin')),
    meta: {
      title: '消息列表'
    }
  },
  {
    path: '/baseInfoHome',
    component: React.lazy(() => import('@/components/BaseInfo')),
    meta: {
      title: '消息中心'
    }
  },
  {
    path: '/baseChatModal',
    component: React.lazy(() => import('@/components/baseChatModal')),
    meta: {
      title: '私聊'
    }
  },
  {
    path: '/member/notActivated',
    component: React.lazy(() => import('@/views/user/member/notActivated')),
    meta: {
      title: 'SVIP权益介绍'
    }
  },
  {
    path: '/',
    component: React.lazy(() => import('@/components/ElectronLayout')),
    meta: {
      title: '996传奇盒子'
    },
    redirect: '/home/homePage',
    children: [
      ...homeRoute,
      ...liveRoute,
      ...newLiveRoute,
      ...userRoute,
      ...competitionRoute,
      ...beautifulGirlRoute,
      {
        path: '/gameDetail',
        component: React.lazy(() => import('@/views/system/gameDetail')),
        meta: {
          title: '游戏详情'
        }
      },
      {
        path: '/awardRanking',
        component: React.lazy(() => import('@/views/system/awardRankings')),
        meta: {
          title: '金屠龙奖'
        }
      },
      {
        path: '/activityPage',
        component: React.lazy(() => import('@/views/system/activityPage')),
        meta: {
          title: '内部打开url页面'
        }
      },
      {
        path: '/gameRecherge',
        component: React.lazy(() => import('@/views/system/gameRecherge')),
        meta: {
          title: '游戏充值'
        }
      },
      {
        path: '/realGame/home',
        component: React.lazy(() => import('@/views/system/realGame')),
        meta: {
          title: '游戏'
        }
      },
      {
        path: '/home/giftReward',
        component: React.lazy(() => import('@/views/system/giftReward')),
        meta: {
          title: '回归礼包'
        }
      }
    ]
  },
  // 以下的路由改动请小心，涉及权限校验模块
  {
    path: '/error',
    meta: {
      title: '错误页面'
    },
    redirect: '/error/404',
    children: [
      {
        path: '/error/404',
        auth: false,
        component: React.lazy(() => import('../views/error/404')),
        meta: {
          title: '页面不存在'
        }
      },
      {
        path: '/error/403',
        auth: false,
        component: React.lazy(() => import('../views/error/403')),
        meta: {
          title: '暂无权限'
        }
      }
    ]
  },
  {
    path: '/*',
    meta: {
      title: '错误页面'
    },
    redirect: '/error/404'
  }
];
export default routes;
